import React, { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";

export default function ModalWarning(props) {
  const { onOk, open } = props;
  return (
    <>
      <SweetAlert
        title={"Faktur ini sudah ada"}
        warning
        show={open}
        reverseButtons
        confirmBtnBsStyle="success"
        confirmBtnText="Ok"
        onConfirm={() => onOk()}
      >
        Faktur yang anda pilih sudah ada dalam transaksi ini
      </SweetAlert>
    </>
  );
}
